import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { nl } from "./nl";

/**
 * Every string this SPA authors lives in `nl/`, never in a component. A sentence the API writes is
 * the API's, printed as it arrives (ADR-0068). Bundled rather than fetched, so `t` answers on the
 * first render and no screen flashes its keys.
 */
export const SUPPORTED_LOCALES = ["nl"] as const;

export type Locale = (typeof SUPPORTED_LOCALES)[number];

export const DEFAULT_LOCALE: Locale = "nl";

void i18n.use(initReactI18next).init({
  resources: { nl },
  lng: DEFAULT_LOCALE,
  fallbackLng: DEFAULT_LOCALE,
  defaultNS: "common",
  // React escapes everything it renders, so i18next escaping again turns an apostrophe in an
  // interpolated korps name into `&#39;` on screen.
  interpolation: { escapeValue: false },
});

export default i18n;
